<template>
  <div class="w-full bg-white border-solid border-b-2 border-gray-200">
    <nav class="container mx-auto flex items-center justify-between" v-if="current">
      <router-link  class="mr-10" v-bind:to="{ name: 'Home' }">
        <h1 class="font-logo text-4xl"><span class="text-gray-600">Rocket</span><span class="text-primary">fid</span></h1>
      </router-link>

      <nav class="flex items-center gap-5 ">
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold"                           :to="{ name: 'campaigns', params: {site: sitekey } }">{{ $t('menu.campaigns') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold"                           :to="{ name: 'Events', params: {site: sitekey } }">{{ $t('menu.events') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold"                           :to="{ name: 'Libraries', params: {site: sitekey } }">{{ $t('menu.libraries') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold" v-if="current.banner"     :to="{ name: 'BannerList', params: {site: sitekey } }">{{ $t('menu.banner') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold" v-if="current.wave"       :to="{ name: 'Waves', params: {site: sitekey } }">{{ $t('menu.waves') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold" v-if="current.nps"        :to="{ name: 'Surveys', params: {site: sitekey } }">{{ $t('menu.surveys') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold" v-if="current.bubble"     :to="{ name: 'Customers', params: {site: sitekey } }">{{ $t('menu.customers') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold" v-if="current.monster"    :to="{ name: 'Challenges', params: {site: sitekey } }">{{ $t('menu.challenges') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold" v-if="current.contest"    :to="{ name: 'Contests', params: {site: sitekey } }">{{ $t('menu.contests') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold" v-if="current.kpiadvice"  :to="{ name: 'Advices', params: {site: sitekey } }">{{ $t('menu.advices') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold" v-if="current.wheel"      :to="{ name: 'Wheels', params: {site: sitekey } }">{{ $t('menu.wheel') }}</router-link>
        <router-link  class="text-gray-600" active-class="border-solid border-b-2 border-primary font-bold"                           :to="{ name: 'Settings', params: {site: sitekey } }"><font-awesome-icon icon="cogs"></font-awesome-icon></router-link>
      </nav>

      <nav class="navigation-right responsive-desktop">
        <div class="sitekeys"  v-click-outside="onClickOutsideGroupActionSitekeyMenu">
          <span class="btn" @click="isOpenedMenuSitekeys = !isOpenedMenuSitekeys">{{ siteName }}</span>

          <div class="group-actions" >
            <div class="trigger" @click="isOpenedMenuSitekeys = !isOpenedMenuSitekeys">
              <font-awesome-icon icon="angle-down"></font-awesome-icon>
            </div>

            <transition name="bounce">
              <div v-if="isOpenedMenuSitekeys" class="group-actions-menu box">
                <ul>
                  <li v-if="sites" v-for="site in sitesSorted" v-bind:key="site.id">
                    <router-link :to="{ name: 'campaigns', params: {site: site.sitekey } }">{{ site.name }}</router-link>
                  </li>
                </ul>
              </div>
            </transition>
          </div>

        </div>
        <div class="separator"></div>
        <div class="user-infos" v-click-outside="onClickOutsideGroupActionProfileMenu">
          <span @click="isOpenedMenuProfil = !isOpenedMenuProfil">{{ name }}</span>

          <div class="group-actions"  >
            <div class="trigger" @click="isOpenedMenuProfil = !isOpenedMenuProfil">
              <font-awesome-icon icon="angle-down"></font-awesome-icon>
            </div>

            <transition name="bounce">
              <div v-if="isOpenedMenuProfil" class="group-actions-menu box">
                <ul>
                  <li @click="openProfil = true">
                    <span>{{ $t('menu.profil') }}</span>
                  </li>
                  <li @click="signOut">
                    <span>{{ $t('menu.signout') }}</span>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </nav>
      <profil v-if="openProfil" :open="openProfil" @close="closeProfil"/>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import profil from '@/pages/profile/Index.vue'

export default {
  name: 'top-menu',

  props: ['enable'],

  components: {profil},

  data () {
    return {
      isOpenedMenuSitekeys: false,
      isOpenedMenuProfil: false,
      responsiveMenu: false,
      openProfil: false
    }
  },
  computed: {
    sitekey () {
      if (this.current) {
        return this.current.sitekey
      }
      return ''
    },
    siteName () {
      if (this.current) {
        return this.current.name
      }
      return ''
    },
    sitesSorted () {
      let sites = []
      if (this.sites) {
        this.sites.forEach((site) => {
          if (site.sitekey !== this.current.sitekey) {
            sites.push(site)
          }
        })
        return sites
      }

      return ''
    },
    ...mapGetters('account', {
      sites: 'sites',
      current: 'currentSite'
    }),

    ...mapGetters('user', {
      me: 'me',
      isAdmin: 'isAdmin'
    }),

    name () {
      let name
      if (this.me && this.me.fname) {
        name = this.me.fname
      }
      if (this.me && this.me.lname) {
        name += ' ' + this.me.lname
      }
      return name
    }
  },
  methods: {
    ...mapActions('user', ['logout']),

    signOut () {
      this.logout()
      this.$router.push('/')
    },

    onClickOutsideGroupActionSitekeyMenu (e) {
      this.isOpenedMenuSitekeys = false
    },

    onClickOutsideGroupActionProfileMenu (e) {
      this.isOpenedMenuProfil = false
    },

    closeMenu () {
      this.responsiveMenu = false
    },
    closeProfil () {
      this.openProfil = false
    }
  }
}
</script>
<style lang="scss" scopped>
  .navigation-right {
    float: right;
    display: flex;
    height: 100%;
    margin: 35px 0;

    > * {
      padding-left: 8px;
      &:hover {
        cursor: pointer;
      }

    }
  }
  .navigation-left {
    float: left;
    display: flex;
    vertical-align: baseline;
    line-height: 24px;
    height: 100%;
    line-height: 60px;
    > a:hover {
      background-color: #e5e5e5;
    }
    > * {
      position: relative;
      transition: all 0.29s ease-in-out 0s;
      display: inline-block;
      padding: 0 15px;
      color: #484848;
      font-weight: 600;
      vertical-align: top;

      h1 {
        margin:0;
      }

      &.router-link-exact-active {
        &:after {
          position: absolute;
          content: "";
          bottom: 0;
          right: 18px;
          left: 18px;
          border-bottom: 3px solid #d0d0d0;
        }
      }
    }
  }

  #menu-top {
    width: 100%;
    height: 60px;
    padding: 0 24px;
    background: #fff;
    // box-shadow: 0 10px 10px 0 rgba(180,180,180,0.2);
    .logo-text {
      text-align: left;
    }

    > div {
      height: 60px;
      line-height: 50px;

      .current-site {
        line-height: 60px;
      }
    }
  }

  .btn {
    height: 32px;
    line-height: 32px;
    font-weight: 600;
    padding: 0;
    border: 0 none;
    border-radius: 3px;
    overflow: hidden;
    display: inline-block;
    align-self: center;
    color: #565656;
  }

  .separator {
    width: 4px;
    height: 32px;
    display: inline-block;
    align-self: center;
    background: #dedede;
    border-radius: 4px;
    margin:0 18px;

  }

  .sitekeys {
    display: flex;
    vertical-align: baseline;
    line-height: 24px;
  }

  .user-infos {
    display: flex;
    vertical-align: baseline;
    line-height: 24px;

    > span {
      align-self: center;
    }
  }

.responsive-mobile {
  display: none;

  &.responsive-mobile-menu {
    position: fixed;
    z-index: 10000;
    top: 0;
    left: -100%;
    height: 100%;
    width: 90%;
    background: #fafafa;
    -webkit-box-shadow: 10px 0 10px 0 rgba(56,56,56,0.2);
    box-shadow: 10px 0 10px 0 rgba(56,56,56,0.2);
    &.active {
      left:0;
      .bars {
        left: 100%;
      }
    }
    .bars {
      font-size: 32px;
      position: absolute;
      top: 13px;
      left: 110%;
    }

    > a {
      display: block;
      float: inherit;
      color: #565656;
      width: 100%;
      height: 80px;
      line-height: 80px;
      font-weight: bold;
      font-size: 16px;
      text-align: center;
      border-bottom: 1px solid #efefef;
    }
  }

}
@media (max-width:600px) {
  .responsive-desktop {
    display: none;
  }
  .responsive-mobile {
    display: block;
  }
  #menu-top {
    .banner {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 60px;
      background: #fff;
      z-index: 10000;
      -webkit-box-shadow: 0 10px 10px 0 rgba(56,56,56,0.2);
      box-shadow: 0 10px 10px 0 rgba(56,56,56,0.2);
      h1.logo-text {
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/TopMenu.vue